module.exports = __webpack_public_path__ + "img/upperabs-endo-mesomorph-female.3ff0cb83.svg";